import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getShopDashboard } from '../../actions/api/shopDashboard';
import { RootState } from '../..';

const initialState = {
  dashboardCategories: {},
  dashboardMarket: {},
  status: 'idle' as 'idle' | 'loading' | 'succeeded' | 'failed',
};
const shopDashboardSlice = createSlice({
  name: 'shopDashboard',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // add cases for async actions here
    builder
      .addMatcher(isAnyOf(getShopDashboard.pending), (state) => {
        state.status = 'loading';
      })
      .addMatcher(isAnyOf(getShopDashboard.fulfilled), (state, action) => {
        state.dashboardCategories = action.payload.categories;
        state.dashboardMarket = action.payload.markets;
        state.status = 'succeeded';
      })
      .addMatcher(isAnyOf(getShopDashboard.rejected), (state) => {
        state.status = 'failed';
      });
  },
});

export default shopDashboardSlice.reducer;

export const selectShopDashboardCategories = (state: RootState) =>
  state.shopDashboard.dashboardCategories;
export const selectShopDashboardMarket = (state: RootState) =>
  state.shopDashboard.dashboardMarket;
export const selectShopDashboardStatus = (state: RootState) =>
  state.shopDashboard.status;
